import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Slide from '@mui/material/Slide';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import Alert from '@mui/material/Alert';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import InputAdornment from '@mui/material/InputAdornment';
import SwapHorizRoundedIcon from '@mui/icons-material/SwapHorizRounded';
import AltRouteRoundedIcon from '@mui/icons-material/AltRouteRounded';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import PersonOutlineRoundedIcon from '@mui/icons-material/PersonOutlineRounded';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';
import { objectHearder, ItmeTypeID } from '../../newDocument/objectdata/typeobject';
import FetchApi from '../../../../customhooks/Functionapi';

const d = new Date();
let  convertdate=""
let convertmonth=d.getMonth()+1;
if(d.getDate() <10){
  convertdate="0"+d.getDate();
}
else{
    convertdate=d.getDate();
}
if(d.getMonth()+1<10){
  convertmonth="0"+convertmonth
}else{
    convertmonth=convertmonth
}
var timestampsnow=d.getFullYear()+"-"+convertmonth+"-"+convertdate+" "+d.getHours()+":"+d.getMinutes()+":"+d.getSeconds();
var timestampsDate=d.getFullYear()+"-"+convertmonth+"-"+convertdate;


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export default function PopUpChangeFlow(props) {
    const FetchApis = new FetchApi()
    const [open, setOpen] = React.useState(false);
    const [dataHearder, setDataHearder] = React.useState(objectHearder)
    const [saleapproved, setSaleapproved] = React.useState([]);
    const [flowrunList, setFlowrunList] = React.useState([]);
    const [dataidFlwo, setDataidFlow] = React.useState("")

    React.useEffect(() => {
        getsaleapproved();
        getJournalById();

    }, [])

    const getJournalById = () => {
        FetchApis.FethcGet(`/document/DocumentById/${props.jourId}`).then(res => {
            if (res) {
                setDataHearder(res.data[0])
                setDataidFlow(res.data[0].FlowrunId)
            }

        })
    }

    const getsaleapproved = () => {

        FetchApis.FethcGet(`/flowsystem/flowgroupbyName`).then(res => {
            if (res) {
                setSaleapproved(res.data);
            }
        })
    }

    //  ส่วนกรเลือก sale เพิ่มแสดง flow running
    const isChangflow = (val) => {

        setDataHearder({ ...dataHearder, FlowrunId: val });
    }

    const handleChangeSale = (e) => {
        var val = e.target.value;
        setDataHearder({
            ...dataHearder, SaleAckUserID: val
        })

        FetchApis.FethcGet(`/flowsystem/flowbyNamelist/${val}`).then(res => {
            if (res) {
                if (res) {
                    setFlowrunList(res.data);
                }

            }
        })

    };

    // update 
    const isUpdateJournal = () => {
        // dataHearder.JournalID
        if (dataidFlwo == dataHearder.FlowrunId) {
            alert("ยังไม่ได้เลือก flow ใหม่")


        } else {
        //  console.log(dataHearder.JournalID+"3")
            var object={
                id:dataHearder.JournalID, 
                jourcode:dataHearder.JournalCode,
                flowid:dataHearder.FlowrunId,
                userchang:dataHearder.UserIDConfirm,
                salename:dataHearder.SaleAckUserID,
                stamptimeUpdate:timestampsnow
            }
            // console.log(object)
            FetchApis.FethcPost(`/document/updateDocumentChengeFlow`,object).then(res => {
                if (res.status == 200) {
                    setTimeout(() => {
                        window.location.href = '/documents'
                    }, 1000);
                    // console.log(res)    
                    setTimeout(() => {
                        setOpen(false);
                    }, 800);

                } else {
                    console.log(res)
                }

            })
        }

    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);

    };

    const isSave=()=>{
         isUpdateJournal();
    }

    // ตัวเลือกผู้ร้องขอ: ใส่ค่าปัจจุบันไว้ด้วยถ้าไม่อยู่ในรายการ
    const saleOptions = saleapproved.map((item) => item.flowName);
    if (dataHearder.SaleAckUserID && !saleOptions.includes(dataHearder.SaleAckUserID)) {
        saleOptions.unshift(dataHearder.SaleAckUserID);
    }

    // ตัวเลือกลำดับอนุมัติ: flow เดิมของเอกสาร + flow ของผู้ร้องขอที่เลือก
    const flowOptions = flowrunList.map((item) => ({ id: String(item.flowId), label: item.detail }));
    if (dataidFlwo !== "" && dataidFlwo != null && !flowOptions.some((f) => f.id === String(dataidFlwo))) {
        flowOptions.unshift({ id: String(dataidFlwo), label: dataHearder.flowDetail, current: true });
    }
    const flowValue = dataHearder.FlowrunId != null && flowOptions.some((f) => f.id === String(dataHearder.FlowrunId))
        ? String(dataHearder.FlowrunId) : "";
    const isChanged = dataidFlwo != dataHearder.FlowrunId;

    return (
        <React.Fragment>
            <Button variant="outlined" onClick={handleClickOpen} startIcon={<SwapHorizRoundedIcon />}>
                Change flow
            </Button>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                TransitionComponent={Transition}
                fullWidth
                maxWidth="sm"
                PaperProps={{ sx: { borderRadius: 3, overflow: 'hidden' } }}
            >
                <DialogTitle id="customized-dialog-title" sx={{ m: 0, px: 3, py: 2.5, pr: 7,
                    background: 'linear-gradient(135deg, #1565c0 0%, #1e88e5 100%)', color: '#fff' }}>
                    <Stack direction="row" spacing={1.75} alignItems="center">
                        <Avatar sx={{ bgcolor: 'rgba(255,255,255,.18)', width: 44, height: 44 }}>
                            <AltRouteRoundedIcon />
                        </Avatar>
                        <Box>
                            <Typography sx={{ fontWeight: 700, fontSize: 18, lineHeight: 1.3 }}>
                                เปลี่ยน Flow ผู้อนุมัติ
                            </Typography>
                            <Typography sx={{ fontSize: 13, opacity: .85 }}>
                                Change approval flow
                            </Typography>
                        </Box>
                    </Stack>
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{ position: 'absolute', right: 12, top: 18, color: '#fff',
                        '&:hover': { bgcolor: 'rgba(255,255,255,.15)' } }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent sx={{ px: 3, pt: '20px !important', pb: 1 }}>
                    <Stack spacing={2.5}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, p: 1.75, borderRadius: 2,
                            bgcolor: '#f4f6f9', border: '1px solid #e3e6ea' }}>
                            <DescriptionOutlinedIcon sx={{ color: '#1565c0' }} />
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                <Typography sx={{ fontSize: 12, color: '#78909c' }}>เอกสาร</Typography>
                                <Typography sx={{ fontWeight: 600, color: '#263238' }}>
                                    {dataHearder.JournalCode || '-'}
                                </Typography>
                            </Box>
                            <Chip size="small" icon={<AccountTreeOutlinedIcon />} label={dataHearder.flowDetail || 'ไม่มี flow'}
                                sx={{ maxWidth: '55%', bgcolor: '#e3f0fd', color: '#1565c0', fontWeight: 500,
                                    '& .MuiChip-icon': { color: '#1565c0' } }} />
                        </Box>

                        <Alert severity="warning" icon={<WarningAmberRoundedIcon fontSize="inherit" />}
                            sx={{ borderRadius: 2 }}>
                            คุณแน่ใจที่จะเปลี่ยน ผู้อนุมัติ ของเอกสารนี้หรือไม่
                        </Alert>

                        <TextField
                            select
                            fullWidth
                            label="ชื่อผู้ร้องขอ"
                            value={dataHearder.SaleAckUserID || ""}
                            onChange={(e) => handleChangeSale(e)}
                            InputProps={{ startAdornment: (
                                <InputAdornment position="start"><PersonOutlineRoundedIcon sx={{ color: '#1565c0' }} /></InputAdornment>
                            ) }}
                        >
                            <MenuItem value="" disabled>เลือกผู้อนุมัติ</MenuItem>
                            {saleOptions.map((name) => (
                                <MenuItem key={name} value={name}>{name}</MenuItem>
                            ))}
                        </TextField>

                        <TextField
                            select
                            fullWidth
                            label="ลำดับอนุมัติ"
                            value={flowValue}
                            onChange={(e) => isChangflow(e.target.value)}
                            helperText={flowrunList.length === 0 ? 'เลือกผู้ร้องขอก่อน เพื่อแสดงลำดับอนุมัติ' : ' '}
                            InputProps={{ startAdornment: (
                                <InputAdornment position="start"><AccountTreeOutlinedIcon sx={{ color: '#1565c0' }} /></InputAdornment>
                            ) }}
                        >
                            <MenuItem value="" disabled>เลือก flow อนุมัติ</MenuItem>
                            {flowOptions.map((f) => (
                                <MenuItem key={f.id} value={f.id}>
                                    {f.label}{f.current ? ' (ปัจจุบัน)' : ''}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Stack>
                </DialogContent>
                <DialogActions sx={{ px: 3, py: 2, gap: 1, borderTop: '1px solid #eceff1' }}>
                    <Button onClick={handleClose} color="inherit" startIcon={<CloseIcon />}
                        sx={{ borderRadius: 2, textTransform: 'none', color: '#546e7a' }}>
                        ยกเลิก
                    </Button>
                    <Button autoFocus variant="contained" onClick={isSave} disabled={!isChanged}
                        startIcon={<SaveRoundedIcon />}
                        sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600, px: 2.5, boxShadow: 'none' }}>
                        บันทึกการเปลี่ยนแปลง
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    );
}